<template>
    <div class="login-container">
        <div class="form-side">
            <div class="login-box">
                <div class="logo">
                    <img src="@/assets/logo.png" alt="Logo Weeduc" />
                </div>
                <form @submit.prevent="handleLogin">
                    <div class="form-group">
                        <label>Email</label>
                        <input 
                            type="email"
                            v-model="email"
                            placeholder="Digite seu email"
                            required
                        />
                    </div>
                    <div class="form-group">
                        <label>Senha</label>
                        <input 
                            type="password"
                            v-model="password"
                            placeholder="Digite sua senha"
                            required
                        />
                    </div>
                    <button type="submit" class="btn-login">Entrar</button>
                </form>
                <div class="links">
                    <a href="#">Esqueceu sua senha?</a>
                </div>
            </div>
        </div>
        <div class="banner-side" style="background-image: url('https://assets.sambaplay.tv/template_banner/aee497a6-1e50-459f-8288-a1ccca99a328/raw.png')">
            <div class="banner-content">
                <!-- <h1>Bem-vindo à Plataforma</h1>
                <p>Acesse os melhores conteúdos educacionais</p> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: ''
        }
    },
    methods: {
        handleLogin() {
            // Implementar lógica de login aqui
            console.log('Login:', this.email, this.password)
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    min-height: 100vh;
}

.banner-side {
    flex: 1;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    position: relative;
}

.banner-side::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
}

.banner-content {
    position: relative;
    text-align: center;
    padding: 1.25rem;
}

.banner-content h1 {
    font-size: 2.5em;
    margin-bottom: 0.9375rem;
}

.form-side {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f6f7f9;
    padding: 2.5rem;
}

.login-box {
    width: 100%;
    max-width: 25rem;
    background: white;
    padding: 2.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.625rem rgba(0,0,0,0.1);
}

.logo {
    text-align: center;
    margin-bottom: 1.875rem;
}

.logo img {
    width: 12.5rem;
}

h2 {
    text-align: center;
    color: #272f3a;
    margin-bottom: 1.875rem;
}

.form-group {
    margin-bottom: 1.25rem;
}

label {
    display: block;
    margin-bottom: 0.5rem;
    color: #757e8a;
}

input {
    width: 100%;
    padding: 0.75rem;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    font-size: 0.875rem;
}

.btn-login {
    width: 93%;
    padding: 0.75rem;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 0.25rem;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: 10px;
}

.btn-login:hover {
    background-color: #555;
}

.links {
    margin-top: 1.25rem;
    text-align: center;
    display: flex;
    justify-content: space-between;
}

.links a {
    color: #757e8a;
    text-decoration: none;
    font-size: 0.875rem;
}

.links a:hover {
    color: #333;
}

@media (max-width: 48rem) {
    .login-container {
        flex-direction: column;
    }
    
    .banner-side {
        display: none;
    }
    
    .form-side {
        padding: 1.25rem;
    }
    
    .login-box {
        padding: 1.25rem;
    }
}
</style>
